import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';

const projectGroups =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'project-groups', id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      upsert: (body) => (id ? patch : post)(url, body),
      setActiveStatus: (flag = true) => put(url.concat('/is-active'), { isActive: flag }),
      delete: () => del(url),
    };
  };

export default projectGroups;
